import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/pro-light-svg-icons';

const UserIcon = ({ className = '', ...rest }) => {
  return <FontAwesomeIcon icon={faUser} {...rest} className={className} />;
};

export default UserIcon;
